import React from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup } from 'rsuite';
import OrderConfirmModal from '../../ConfirmationModal';

function CancelOrderConfirmationModal({
  show,
  onCancel,
  onConfirm,
  onSelectOption,
  confirmButtonProps
}) {
  const handleSelectOption = value => {
    onSelectOption(value);
  };

  return (
    <OrderConfirmModal
      show={show}
      title="Cancel Order"
      onCancel={onCancel}
      onConfirm={onConfirm}
      confirmButtonProps={confirmButtonProps}
    >
      <p style={{ marginBottom: 10 }}>
        Are you sure you want to cancel your order?
      </p>
      <RadioGroup onChange={handleSelectOption}>
        <Radio value>Yes, Return Items to stock.</Radio>
        <Radio value={false}>Yes, Set the items as lost.</Radio>
      </RadioGroup>
    </OrderConfirmModal>
  );
}

CancelOrderConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onSelectOption: PropTypes.func.isRequired,
  confirmButtonProps: PropTypes.shape({}).isRequired
};

export default CancelOrderConfirmationModal;
